import { HANDLE_FORM, RESET_FORM, RESET } from '../actions';
import moment from "moment";

const initialState = {
    no: "1",
    date: moment().format("DD-MM-YYYY"),
    main_agent_id: "",
    sub_agent_id: "",
    area: "",
    pvc5: "",
    pvc6: "",
    pvc7: "",
    pvc8: "",
    pvc9: "",
    pvc10: "",
    ms7: "",
    ms7_type: "M",
    ms8: "",
    ms8_type: "M",
    ms9: "",
    ms9_type: "M",

    ending_rpm: "",
    starting_rpm: "",
    total_rpm: "",
    welding: "",
    feetage: "",
    water: "",
    total_depth: "",
    total_rod: "",
    first_bit_name: "",
    first_bit_size: "",
    first_bit_to: "",
    first_bit_depth: "",
    second_bit_name: "",
    second_bit_size: "",
    second_bit_to: "",
    second_bit_depth: "",
    diesel_rate: "",
    diesel_liters: "",
    diesel_amount: "",
    total_diesel: "",
    loose_soil: "",
    loose_soil_to: "",
    bolders_soil: "",
    bolders_soil_to: "",
    driller_id: "",
    remarks: "",
    total_depth_rate: "",

    hammer_name: "",
    hammer_depth: "",

    formList: [],

    total_feet_inch: "",
    total_feet_rate: "",
    total_feet_amount: "",
    welding_charge: "",
    welding_rate: "",
    welding_amount: "",
    transport_charge: "",
    total_point_amount: "",

    vehicle_id: "",

    formList: [],
    vehicleSelected: "",
    startDateFilter: moment().format("YYYY-MM-DD"),
    endDateFilter: moment().format("YYYY-MM-DD"),


    point_advance: "",
    diesel_date: null,
    rig_oil_service: "",
    compressor_engine_oil_service: "",
    compressor_oil_service: "",

    cap: "",
    cap_rate: "",
    cap_amount: "",

    collar: "",
    collar_rate: "",
    collar_amount: "",

    filter_pipe: "",
    filter_pipe_rate: "",
    filter_pipe_amount: "",

    amount_collected: "",

    customer_name: "",
    customer_phone: "",

    first_bit_previous_depth: "",
    first_bit_running_depth: "",
    first_bit_total_depth: "",

    second_bit_previous_depth: "",
    second_bit_running_depth: "",
    second_bit_total_depth: "",

    hammer_previous_depth: "",
    hammer_running_depth: "",
    hammer_total_depth: "",

    pvc5_rate: "",
    pvc6_rate: "",
    pvc7_rate: "",
    pvc8_rate: "", 
    pvc9_rate: "",
    pvc10_rate: "",

    pvc5_amount: "",
    pvc6_amount: "",
    pvc7_amount: "",
    pvc8_amount: "",
    pvc9_amount: "",
    pvc10_amount: "",

    ms7_rate: "",
    ms8_rate: "",
    ms9_rate: "",

    ms7_amount: "",
    ms8_amount: "",
    ms9_amount: "",
};

const Form = (state = initialState, action) => {
    
    switch (action.type) {
        case HANDLE_FORM:
            return {
                ...state,
                ...action.data
            };
        case RESET_FORM:
            return {
                ...initialState,
                vehicleSelected: state.vehicleSelected,
                formList: state.formList
            }
        case RESET:
            return initialState;
        default:
            return state;
    }
};

export default Form;